<template>
  <div>
    <div class="is-flex" :class="{ 'bg-grey-11': isEmptyRow(source.list) }">
      <!-- DATA COLUMN -->
      <div
        v-if="source.list.length > 0"
        class="is-flex"
        :class="{ 'c-w-100': isShrink }"
      >
        <div
          v-for="(itemColumn, indexColumn) in source.list"
          :key="`item-column-${indexColumn}`"
          :style="{ width: `${widthColumn}px`, height: `${heightColumn}px` }"
          class="column-status px-1 flex-center-vertical"
          :class="[
            getColumnClass(indexColumn, itemDaily.date, source.survey_id, itemColumn),
            {
              'bg-light-blue-2': idxSelectedStatus && idxSelectedStatus === indexColumn,
              'border-bottom-none': index + 1 === itemDaily.project_length,
              'shrink-status': isShrink
            }
          ]"
          :ref="`column-${itemDaily.date}-${source.survey_id}-${
            itemColumn && itemColumn.status_name
          }`"
          @mouseleave="(e) => handleMouseLeave(e, itemColumn, indexColumn)"
          @click="handleClickColumn"
        >
        <!-- @mouseenter="
          (e) =>
            handleMouseEnter(e, itemColumn, indexColumn, {
              surveyId: source.survey_id,
              status: itemColumn.status_name
            })
        " -->
          <div
            v-if="itemColumn && Object.keys(itemColumn).length > 0"
            class="c-w-100 c-h-100 is-relative"
          >
            <div class="c-w-100 c-h-100">
              <div class="flex-center c-w-100 c-h-100 overflow-auto overflow-x-hidden">
                <div class="max-c-h-100 c-w-100 is-flex is-flex-direction-column">
                  <div
                    class="flex-center-vertical is-justify-content-space-between c-w-100"
                    :class="{
                      'm-auto':
                        [itemColumn.start_due_date, itemColumn.status_late, itemColumn.late].filter(
                          (field) => field
                        ).length >= 2
                    }"
                  >
                    <div class="is-flex c-w-90" :class="{ 'is-flex-direction-column': isShrink }">
                      <p class="color-gray label-14 mr-1">
                        {{ source.survey_id }}
                      </p>
                      <div class="ellipsis-content">
                        <p
                          class="averta-bold label-14"
                          :class="{
                            'color-grey': 'worker_absent' in itemColumn && !itemColumn.worker_absent
                          }"
                        >
                          <span v-if="!isShrink">| </span>{{ source.store_name }}
                        </p>
                      </div>
                    </div>
                    <div
                      class="is-clickable flex-shrink-0"
                      @click.stop="
                        (e) =>
                          handleTooltip(e, indexColumn, {
                            itemColumn,
                            surveyId: source.survey_id,
                            status: itemColumn.status_name,
                          })
                      "
                    >
                      <div v-if="itemColumn.background === 'danger'">
                        <AlertIcon size="18" color="#E10009" />
                      </div>
                      <div v-else>
                        <img
                          :src="require('@/assets/img/info-blue.png')"
                          style="height: 19px"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>

                  <div class="tag-wrapper-report">
                    <!-- JATUH TEMPO -->
                    <div
                      v-if="itemColumn.start_due_date"
                      class="flex-center-vertical border-radius-100 py-1 px-2 mt-1 mr-1 bg-grey-11 flex-shrink-0 is-inline-flex c-w-100"
                    >
                      <p class="label-11 ellipsis-content">
                        Jatuh Tempo :
                        {{ formatDate(itemColumn.start_due_date, 'DD/MM/YY') }} -
                        {{ formatDate(itemColumn.end_due_date, 'DD/MM/YY') }}
                      </p>
                    </div>

                    <!-- TELAT HARI KE-N -->
                    <div
                      v-if="itemColumn.late || itemColumn.date_late"
                      class="flex-center-vertical is-justify-content-space-between border-radius-100 py-1 px-2 mt-1 mr-1 color-red flex-shrink-0 is-inline-flex c-w-100"
                      :class="{
                        'bg-pink-2': !itemColumn.background,
                        'bg-white': itemColumn.background === 'danger',
                        'c-w-100': itemColumn.arrow
                      }"
                    >
                      <div class="is-flex ellipsis-content">
                        <p class="label-11" v-if="itemColumn.late">
                          Telat {{ itemColumn.late }} Hari
                        </p>
                        <p class="ml-1 averta-bold label-11">
                          ({{ formatDate(itemColumn.date_late, 'DD/MM/YYYY') }})
                        </p>
                      </div>

                      <div
                        v-if="itemColumn.concept === 'beginning' && itemColumn.date_late"
                        class="icon-arrow-blue flex-shrink-0"
                        @click.stop="
                          handleClickArrow({
                            ...itemColumn,
                            survey_id: source.survey_id
                          })
                        "
                      >
                        <img
                          v-if="itemColumn.arrow === 'down'"
                          src="@/assets/icons/arrow-down-blue-used.svg"
                          alt=""
                        />
                        <img
                          v-if="itemColumn.arrow === 'up'"
                          src="@/assets/icons/arrow-up-blue-used.svg"
                          alt=""
                        />
                      </div>
                    </div>

                    <!-- PENAWARAN DITOLAK -->
                    <div v-if="itemColumn.status_late" class="is-inline-flex">
                      <div
                        class="border-radius-100 py-1 px-2 mt-1 mr-1 flex-shrink-0 is-inline-block"
                        :class="{
                          'bg-red-3': itemColumn.status_late === 'Penawaran Ditolak',
                          'bg-session-4': itemColumn.status_late === 'Penawaran Revisi'
                        }"
                      >
                        <p class="label-11 color-white">
                          {{ itemColumn.status_late }}
                        </p>
                      </div>
                    </div>

                    <!-- EXTEND PROYEK -->
                    <div
                      v-if="itemColumn.extend"
                      class="flex-center-vertical border-radius-100 py-1 px-2 mt-1 mr-1 color-red flex-shrink-0 bg-white is-align-self-flex-start is-inline-flex"
                    >
                      <InfoOutlineIcon />
                      <p class="label-11">
                        Extend Proyek :
                        {{ `${itemColumn.extend_day}/${itemColumn.extend}` }} Hari
                      </p>
                    </div>

                    <!-- SURVEY RESCHEDULE -->
                    <div
                      v-if="'survey_reschedule' in itemColumn && itemColumn.survey_reschedule"
                      class="border-radius-100 py-1 px-2 mt-1 mr-1 color-red bg-pink-6 flex-shrink-0 is-align-self-flex-start is-inline-flex"
                    >
                      <p class="label-11 color-dark-red-3">Survey Reschedule</p>
                    </div>

                    <!-- ABSENT -->
                    <div v-if="indexColumn === 13">
                      <!-- <TagStatus title="started" /> -->
                      <!-- <TagStatus title="no-slot-yet" /> -->

                      <!-- <TagStatus title="continued" /> -->
                      <!-- <TagStatus title="un-assigned" /> -->

                      <!-- <TagStatus title="continued" /> -->
                      <TagStatus
                        v-if="'worker_absent' in itemColumn"
                        :title="itemColumn.worker_absent ? 'checked-in' : 'not-checked-in'"
                      />

                      <!-- <TagStatus title="continued" /> -->
                      <!-- <TagStatus title="checked-in" /> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- EMPTY COLUMN (18) -->
      <div v-else>
        <EmptyColumnProgress
          :heightColumnProps="heightColumn"
          :heightColumnDailyProps="heightColumnDaily"
          :widthColumnProps="widthColumn"
          :hideDaily="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import {
  alertErrorMessage,
  formatDateHelper,
  getStatusClassName,
  titleReportProgress
} from '@/helpers'
import { mapGetters } from 'vuex'

export default {
  name: 'ListColumn',
  props: {
    index: {
      type: Number,
      default: 0
    },
    source: {
      type: Object,
      default () {
        return {}
      }
    },
    indexWeek: {
      type: [Number, String],
      default: null
    },
    indexDaily: {
      type: [Number, String],
      default: null
    },
    idxSelectedStatus: {
      type: [Number, String],
      default: null
    },
    dataProgressLength: {
      type: [Number, String],
      default: null
    },
    fromDate: {
      type: String,
      default: null
    },
    toDate: {
      type: String,
      default: null
    },
    itemDaily: {
      type: Object,
      default () {
        return {
          date: null,
          today: false,
          project_length: 0
        }
      }
    },
    getColumnClassProps: {
      type: Function,
      default () {}
    },
    handleClickArrowProps: {
      type: Function,
      default () {}
    },
    handleConfirmTooltipProps: {
      type: Function,
      default () {}
    }
  },
  components: {
    AlertIcon: () => import('@/components/icons/AlertIcon.vue'),
    InfoOutlineIcon: () => import('@/components/icons/InfoOutlineIcon.vue'),
    // eslint-disable-next-line vue/no-unused-components
    TagStatus: () => import('./TagStatus.vue')
  },
  computed: {
    ...mapGetters({
      tooltip: 'report/getTooltipCardProgress'
    }),
    isShrink () {
      return this.scaleTable < 0.6
    }
  },
  data () {
    return {
      dataTooltip: null,

      widthColumn: 260,
      heightColumn: 93,
      heightColumnDaily: 60,
      scaleTable: 1
    }
  },
  methods: {
    handleMouseEnter (e, itemColumn, indexColumn, props) {
      if (!itemColumn || Object.keys(itemColumn).length === 0) return

      const card = e.currentTarget.getBoundingClientRect()
      const x = card.right + 10
      const y = card.top + window.scrollY

      this.$store.commit('report/setTooltipCardProgress', {
        x,
        y,
        visible: true,
        hover_tooltip: true,
        index_column: indexColumn
      })
      if (!this.tooltip.loading) {
        this.getTooltipInformation(props)
      }
    },
    handleMouseLeave (e, itemColumn, indexColumn) {
      setTimeout(() => {
        if (!this.tooltip.hover_tooltip) {
          this.$store.commit('report/setTooltipCardProgress', {
            x: 0,
            y: 0,
            visible: false,
            index_column: indexColumn
          })
        }
      }, 250)
    },
    isEmptyRow (data) {
      return data.every((obj) => (!obj ? true : Object.keys(obj).length === 0))
    },
    formatDate (date, format) {
      if (!date) return ''
      return formatDateHelper({ date, format })
    },
    titleStatus (status) {
      return titleReportProgress(status)
    },
    closeTooltip () {
      this.$store.commit('report/setTooltipCardProgress', {
        visible: false,
        data: null
      })
    },
    handleTooltip (e, indexColumn, props) {
      if (this.tooltip.data) {
        if (this.tooltip.data.survey_id === props.surveyId) {
          this.closeTooltip()
          return
        }
      }

      const card = e.currentTarget.getBoundingClientRect()
      const tooltipWidth = 430
      const tooltipHeight = 310
      const padding = 10

      let x = card.right + padding + 10
      let y = card.top + window.scrollY - 30

      // cek sisi kanan viewport
      if (x + tooltipWidth > window.innerWidth) {
        x = card.left - tooltipWidth - padding
      }

      // cek sisi bawah viewport
      if (y + tooltipHeight > window.innerHeight + window.scrollY) {
        y = card.bottom + window.scrollY - tooltipHeight - padding + 100
      }

      this.$store.commit('report/setTooltipCardProgress', {
        x,
        y,
        visible: true,
        hover_tooltip: true,
        index_column: indexColumn,
        tooltip_target: e.currentTarget
      })

      if (!this.tooltip.loading) {
        this.getTooltipInformation(props)
      }
    },
    handleClickArrow (item) {
      this.handleClickArrowProps(item)
    },
    handleClickColumn () {
      if (this.tooltip.visible) {
        this.closeTooltip()
      }
    },
    getColumnClass (indexColumn, date, surveyId, column) {
      return this.getColumnClassProps(indexColumn, date, surveyId, column)
    },
    getClassName (status) {
      return getStatusClassName(status)
    },
    getTooltipInformation (props = {}) {
      // eslint-disable-next-line camelcase
      const { surveyId, status, itemColumn } = props
      this.$store.commit('report/setTooltipCardProgress', { loading: true })

      const payload = {
        surveyId,
        status,
        startDate: this.fromDate,
        endDate: this.toDate
      }

      this.$store
        .dispatch('report/getTooltipInformation', payload)
        .then((res) => {
          const data = {
            ...res.data.data,
            ...this.source
          }

          if ('worker_absent' in itemColumn) {
            data.worker_absent = itemColumn.worker_absent
          }
          this.$store.commit('report/setTooltipCardProgress', {
            data,
            loading: false
          })
        })
        .catch((err) => {
          this.$store.commit('report/setTooltipCardProgress', { loading: false })
          alertErrorMessage(err)
        })
    },
    updateZoom (val) {
      // Scale from 0.7 (slider=0) to 1 (slider=100)
      this.scaleTable = 0.495 + (val / 100) * 0.505
      this.adjustMaxHeightTable(this.scaleTable)
    },
    adjustMaxHeightTable (val) {
      if (val < 0.6) {
        this.widthColumn = 150
      } else {
        this.widthColumn = 260
      }
    }
  },
  mounted () {
    this.updateZoom(this.tooltip.zoom)
  },
  created () {},
  watch: {
    tooltip: {
      handler (val) {
        this.updateZoom(val.zoom)
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';
.column-status {
  border: 1px solid $color-grey-10;
  border-left-width: 0;
  border-top-width: 0;
  background: transparent;
  transition: background 0.3s ease-in-out;
}

@keyframes slow-blink {
  0% {
    background-color: transparent;
  }
  50% {
    background-color: #e1eeff;
  }
  100% {
    background-color: transparent;
  }
}

.column-status {
  &.is-highlight {
    background-color: #e1eeff;
    animation: slow-blink 2s ease-in-out 2;
  }
  &.shrink-status {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.icon-arrow-blue {
  width: 15px;
  flex-shrink: 0;
  transform: scale(1.5);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
</style>
